import { Dialog } from "material-ui";
import Clear from "material-ui/svg-icons/content/clear";
import CheckBox from "material-ui/svg-icons/toggle/check-box";
import React from "react";
import { FormattedMessage } from "react-intl";
import { ActionButton, closeIconStyle } from "./RoomActionDialog";

class RoomOptions extends React.Component {
  render() {
    return (
      <Dialog
        modal={true}
        open={true}
        onRequestClose={this.props.handleClose}
        contentStyle={{ width: "95%", maxWidth: "450px" }}
      >
        <Clear onClick={this.props.handleClose} style={closeIconStyle} />
        <div>
          <div className="flex item-center justify-center mt3">
            <CheckBox style={{ color: "rgb(101, 114, 133)" }} />
            <span style={{ lineHeight: "25px" }} className="ml2">
              {<FormattedMessage id={this.props.isRoomUpdated ? "roomList.roomUpdated" : "roomList.roomCreated"} />}
            </span>
          </div>
        </div>

        <div className="room-options-container mt3 mb2">
          <ActionButton onTouchTap={this.props.sendInvitation} label="sendInvitation" />
          <ActionButton labelTransform={true} onTouchTap={this.props.addToGoogleCalendar} label="googleCalendar" />
        </div>
      </Dialog>
    );
  }
}

export default RoomOptions;



// WEBPACK FOOTER //
// src/components/Seminars/RoomOptions.js